import { render, staticRenderFns } from "./ComplaintFiles.vue?vue&type=template&id=dc6cc11e&scoped=true"
import script from "./ComplaintFiles.vue?vue&type=script&lang=js"
export * from "./ComplaintFiles.vue?vue&type=script&lang=js"
import style0 from "./ComplaintFiles.vue?vue&type=style&index=0&id=dc6cc11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6cc11e",
  null
  
)

export default component.exports